// Locale Actions
export const Show_Loader = "Show_Loader";
export const Remove_Loader = "Remove_Loader";